import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import PageRichText from "./PageRichText";
import { usePageTextBlock } from "./usePageTextBlock";

interface Props {
  element: DocumentElementType;
}

/**
 * A page-document rich-text block. Thin adapter: it reads the document context
 * (edit-in-place write-path + Notion Enter/Backspace/autofocus) via
 * `usePageTextBlock` and hands it to the shared PageRichText editor. Content is
 * stored as HTML in `data.content`.
 */
const PageText: React.FC<Props> = ({ element }) => {
  const { richTextProps } = usePageTextBlock(element);
  return <PageRichText {...richTextProps} />;
};

export default PageText;
